import { useEffect, useState } from "react";
import api from "@/lib/api";
import { WhatsappLogo } from "@phosphor-icons/react";

// Floating WhatsApp button — ALWAYS uses the Booking Manager number.
// Never the GM. Cache in memory to avoid refetching on every mount.
let _cached = null;
let _pending = null;

async function fetchManager() {
  if (_cached) return _cached;
  if (_pending) return _pending;
  _pending = (async () => {
    try {
      const { data } = await api.get("/public/contact-manager");
      _cached = data;
      return data;
    } catch {
      return null;
    } finally {
      _pending = null;
    }
  })();
  return _pending;
}

export default function WhatsAppFab({ prefillText }) {
  const [mgr, setMgr] = useState(_cached);

  useEffect(() => {
    if (!mgr) fetchManager().then(setMgr);
  }, [mgr]);

  const phone = String(mgr?.phone || "").replace(/\D/g, "");
  if (!phone) return null;

  const text = encodeURIComponent(
    prefillText ||
      "السلام عليكم\nأرغب بالاستفسار عن خدمات مراسم الزوار.",
  );
  const href = `https://wa.me/${phone}?text=${text}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="wa-manager-fab"
      aria-label={`واتساب ${mgr?.name || "مدير الحجوزات"}`}
      className="fixed z-40 bottom-24 left-4 sm:left-6 inline-flex items-center gap-2 h-14 pl-4 pr-5 rounded-full shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] bg-[#25D366] hover:bg-[#20b858] text-white font-bold transition-all hover:scale-105"
      style={{ boxShadow: "0 10px 30px -8px rgba(37,211,102,0.55)" }}
    >
      <WhatsappLogo size={26} weight="fill" />
      <span className="hidden sm:inline text-sm">مدير الحجوزات</span>
    </a>
  );
}
